// MBSPros UI — entry points
import { RestfulEndpoint } from 'type-r/endpoints/restful'
RestfulEndpoint.defaultFetchOptions.redirect = 'follow';

export { initLoginPage } from './login';
export { initCalendar, goMonth } from './calendar';
export { goMsg } from './contact';
export { initForm, updateTime } from './form';
export { initEventChart } from './event_detail';
export { initSettings } from './settings';
export { initSignup, initUpgrade, initCustomer, initLicense, initDevFill } from './accts';
export { initDashboard } from './dashboard';

